import api from './api';

const trimTrailingSlash = (value) => {
  if (!value) return '';
  return value.endsWith('/') ? value.slice(0, -1) : value;
};

/** Base da API sem path extra (ex.: http://localhost:8080). */
export const getApiOrigin = () => {
  const raw = import.meta.env.VITE_API_URL || 'http://localhost:8080';
  const trimmed = trimTrailingSlash(raw);
  return trimmed.replace(/\/api$/i, '');
};

export const getAdminWidgetConfigs = async () => {
  const response = await api.get('/api/private/widgets/admin');
  return response.data;
};

export const upsertWidgetConfig = async (appOriginCode, payload) => {
  const response = await api.put(
    `/api/private/widgets/${encodeURIComponent(appOriginCode)}`,
    payload
  );
  return response.data;
};

export const buildWidgetSnippet = ({ appOriginCode, apiBaseUrl, embedBaseUrl }) => {
  const origin = embedBaseUrl || (typeof window !== 'undefined' ? window.location.origin : '');
  const apiBase = apiBaseUrl || getApiOrigin();
  const code = appOriginCode || 'SEATHUB';

  return `<!-- Support Hub Widget: monte numa div do app host -->
<div id="supporthub-widget-slot" style="width:100%;min-height:64px;height:480px;"></div>
<script src="${origin}/widget.js" data-api-base="${apiBase}" async></script>
<script>
  // No app host: peça o embedToken ao SEU backend (client_credentials + POST /api/private/widgets/embed-session).
  async function getEmbedTokenFromHostBff() {
    const res = await fetch('/seu-bff/supporthub-embed-session', { credentials: 'include' });
    const data = await res.json();
    return data.embedToken;
  }

  function bootSupportHubWidget() {
    if (!window.SupportHubWidget) {
      setTimeout(bootSupportHubWidget, 50);
      return;
    }
    window.SupportHubWidget.mount(document.getElementById('supporthub-widget-slot'), {
      appOrigin: '${code}',
      apiBaseUrl: '${apiBase}',
      embedUrl: '${origin}/embed/user/tickets',
      getEmbedToken: getEmbedTokenFromHostBff,
    });
  }
  bootSupportHubWidget();
</script>`;
};
